export const CONTR_QFT_MNT_EVENT_LIST = 'CONTR_QFT_MNT_EVENT_LIST';
export const ADD_QFT_MNT_EVENT_SUCCESS = 'ADD_QFT_MNT_EVENT_SUCCESS';
export const EDIT_QFT_MNT_EVENT_SUCCESS = 'EDIT_QFT_MNT_EVENT_SUCCESS';
export const QFT_MNT_COND_CRUD = 'QFT_MNT_COND_CRUD';
export const TOGGLE_VIEW_EDIT = 'TOGGLE_VIEW_EDIT';
export const QFD_MNT_LOADER = 'QFD_MNT_LOADER';
export const RESERVE_ACNT_LIST = 'RESERVE_ACNT_LIST';
